// extracted by mini-css-extract-plugin
export default {"cursorIcon":"bhlAAtu"};